<template>
<div>
  <v-row>
    <v-col
      cols="12"
      md="12"
      lg="12"
      class="pb-0"
    >
      <v-text-field
        v-model="ticket.ntdSerialNumber"
        label="NTD Serial number	"
        placeholder=" "
        outlined
        dense
        :readonly="false"
      ></v-text-field>
    </v-col>

    <v-col
      cols="12"
      :md="6"
      class="pt-0 pb-1"
    >
      <ValidationProvider
        name="NTD Type"
        :rules="'required'"
        v-slot="{ errors }"
      >
        <v-select
          :items="ntdTypes"
          label="NTD Type"
          name="NTD Type"
          outlined
          placeholder="Please select NTD Type"
          v-model="ticket.ntdType"
        ></v-select>
      </ValidationProvider>
    </v-col>

    <v-col
      cols="12"
      :md="6"
      class="pt-0 pb-1"
    >
      <ValidationProvider
        name="NTD LEDs Power Status"
        :rules="'required'"
        v-slot="{ errors }"
      >
        <v-select
          :items="PowerStatusOptions"
          label="NTD LEDs Power Status"
          name="NTD LEDs Power Status"
          outlined
          placeholder="Please select Power Status"
          v-model="ticket.ntdPowerStatus"
        ></v-select>
      </ValidationProvider>
    </v-col>

    <v-col
      cols="12"
      :md="6"
      class="pt-0 pb-1"
    >
      <ValidationProvider
        name="NTD LEDs DS Status"
        :rules="'required'"
        v-slot="{ errors }"
      >
        <v-select
          :items="NtdDsUsStatusOptions"
          label="NTD LEDs DS Status"
          name="NTD LEDs DS Status"
          outlined
          placeholder="Please select DS Status"
          v-model="ticket.ntdDsStatus"
        ></v-select>
      </ValidationProvider>
    </v-col>

    <v-col
      cols="12"
      :md="6"
      class="pt-0 pb-1"
    >
      <ValidationProvider
        name="NTD LEDs US Status"
        :rules="'required'"
        v-slot="{ errors }"
      >
        <v-select
          :items="NtdDsUsStatusOptions"
          label="NTD LEDs US Status"
          name="NTD LEDs US Status"
          outlined
          placeholder="Please select US Status"
          v-model="ticket.ntdUsStatus"
        ></v-select>
      </ValidationProvider>
    </v-col>

    <v-col
      cols="12"
      :md="6"
      class="pt-0 pb-1"
    >
      <ValidationProvider
        name="NTD LEDs Online Status"
        :rules="'required'"
        v-slot="{ errors }"
      >
        <v-select
          :items="OnlineStatusOptions"
          label="NTD LEDs Online Status"
          name="NTD LEDs Online Status"
          outlined
          placeholder="Please select Online Status"
          v-model="ticket.ntdOnlineStatus"
        ></v-select>
      </ValidationProvider>
    </v-col>


    <v-col
      cols="12"
      :md="6"
      class="pt-0 pb-1"
    >
      <ValidationProvider
        name="NTD LEDs Link Status"
        :rules="'required'"
        v-slot="{ errors }"
      >
        <v-select
          :items="NtdLinkStatusOptions"
          label="NTD LEDs Link Status"
          name="NTD LEDs Link Status"
          outlined
          placeholder="Please select Link Status"
          v-model="ticket.ntdLinkStatus"
        ></v-select>
      </ValidationProvider>
    </v-col>
    <v-col
      cols="12"
      md="12"
      lg="12"
      class="pb-0"
    >
      <v-radio-group
        row
        v-model="ticket.homeAmplifierInstalled"
      >
        <label class="mr-2">Is there an In Home Amplifier already installed at the premises?</label>
        <v-radio label="Yes" value="Yes"></v-radio>
        <v-radio label="No" value="No"></v-radio>
      </v-radio-group>
    </v-col>
    <v-col
      cols="12"
      md="12"
      lg="12"
      class="pb-0"
    >
      <v-radio-group
        row
        v-model="ticket.homeAmplifierInstalledPower"
      >
        <label class="mr-2">If In Home Amplifier installed, is it currently powered on?</label>
        <v-radio label="Yes" value="Yes"></v-radio>
        <v-radio label="No" value="No"></v-radio>
      </v-radio-group>
    </v-col>
  </v-row>
</div>
</template>

<script>
export default {
  name: "nbn-check-list-details-hfc",
  props: {
    ticket: { type: Object },
  },
  data: () => ({
    NtdTypes :[
      {text: "CM820 DM3.0", value: "CM820 DM3.0", disabled: false},
      {text: "CM8200B DM3.1", value: "CM8200B DM3.1", disabled: false},
    ]
  }),
  computed: {
    PowerStatusOptions() {
      let vm = this;
      let options = [];
      if (vm.ticket.ntdType == 'CM820 DM3.0') {
        options = [
          {text: "On", value: "On", disabled: false},
          {text: "Off", value: "Off", disabled: false},
          {text: "Flashing", value: "Flashing", disabled: false},
        ]
      } else if(vm.ticket.ntdType == 'CM8200B DM3.1') {
        options = [
          {text: "On", value: "On", disabled: false},
          {text: "Off", value: "Off", disabled: false},
        ]
      }
      return options;
    },
    OnlineStatusOptions() {
      let vm = this;
      let options = [];
      if (vm.ticket.ntdType == 'CM820 DM3.0') {
        options = [
          {text: "On", value: "On", disabled: false},
          {text: "Off", value: "Off", disabled: false},
          {text: "Flashing", value: "Flashing", disabled: false},
        ]
      } else if(vm.ticket.ntdType == 'CM8200B DM3.1') {
        options = [
          {text: "Off", value: "Off", disabled: false},
          {text: "Green", value: "Green", disabled: false},
          {text: "Flashing", value: "Flashing", disabled: false},
        ]
      }
      return options;
    },
    NtdDsUsStatusOptions() {
      let vm = this;
      let options = [];
      if (vm.ticket.ntdType == 'CM820 DM3.0') {
        options = [
          {text: "Yellow", value: "Yellow", disabled: false},
          {text: "Green", value: "Green", disabled: false},
          {text: "Flashing", value: "Flashing", disabled: false},
        ]
      } else if(vm.ticket.ntdType == 'CM8200B DM3.1') {
        options = [
          {text: "Off", value: "Off", disabled: false},
          {text: "Green", value: "Green", disabled: false},
          {text: "Flashing", value: "Flashing", disabled: false},
        ]
      }
      return options;
    },
    NtdLinkStatusOptions() {
      let vm = this;
      let options = [];
      if (vm.ticket.ntdType == 'CM820 DM3.0') {
        options = [
          {text: "Yellow", value: "Yellow", disabled: false},
          {text: "Green", value: "Green", disabled: false},
          {text: "Off", value: "Off", disabled: false},
          {text: "Flashing", value: "Flashing", disabled: false},
        ]
      } else if(vm.ticket.ntdType == 'CM8200B DM3.1') {
        options = [
          {text: "Off", value: "Off", disabled: false},
          {text: "Flashing Amber", value: "Flashing Amber", disabled: false},
          {text: "Flashing Green", value: "Flashing Green", disabled: false},
        ]
      }
      return options;
    },
  }
}
</script>

<style scoped>

</style>
